import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef} from '@angular/material';
import { DefineAreaModalComponent } from 'app/define-area-modal/define-area-modal.component';
import {isUndefined} from "util";
import {RestApiService} from '../shared/restApiServices/restapi.service';
declare var amplitude:any;


@Component({
  selector: 'app-new-group-dialog',
  templateUrl: './new-group-dialog.component.html',
  styleUrls: ['./new-group-dialog.component.css']
})
export class NewGroupDialogComponent implements OnInit {

  groupName:string;
  userId:string[]=[];
  qNames:string[]=[];
  qId:string[]=[];
  areaDefined:{details:{name:string,radius:string,limit:string,responses:string}[],
                lat:string[],lng:string[],qID:string}[]=[];
  groupEmpty:string;
  // description:string;
  failMsg:string;

  selectedTab:"createTeam"|"addSurveyor"|"assignTeam"|"defineArea" = "createTeam";
  surveyorList: {uid:string,surveyor:string,mobileNo:string,addedOn:string,action:boolean}[]=[]
  displayedColumns: string[] = [ 'surveyor', 'mobileNo' , 'addedOn','action'];

  surveyList: {qid:string,survey:string,createdOn:string,status:string,action:boolean,
    defineArea:boolean}[]=[]
  displayedColumns2: string[] = [ 'survey', 'createdOn' , 'status','action','defineArea'];

  constructor(private restApiService:RestApiService,
    public newGroupDialogRef: MatDialogRef<NewGroupDialogComponent>,private dialog:MatDialog) { }

  ngOnInit() {

    this.getSurveyList();
    this.getSurveyorList();
  }

  getSurveyorList(){
    this.restApiService.getSurveyerList(null,null,null,null).subscribe(
      response => {
        if(response && response.success){
          const result = response.Users;
          this.surveyorList = [];
          if(result && result.length>0){
            result.forEach(data=>{
              if(data.uID){
                const createdDate = data.createdAt.substring(0,10);
                this.surveyorList.push({uid:data.uID,surveyor:data.Name,mobileNo:data.userName,
                  addedOn:createdDate, action:false});
              }
            })
          }
        }
      });
  }

  getSurveyList(){
    this.restApiService.getQnrListService().subscribe(
      response => {
        if(response && response.success){
          const result = response.result;
          this.surveyList = [];
          if(result && result.length>0){
            result.forEach(data=>{
              const createdDate = data.createdAt.substring(0,10);
              let status  = data.status == 'p'?'Published':'draft';
              this.surveyList.push({qid:data.qID,survey:data.surveyName,createdOn:createdDate,
                status:status, action:false,defineArea:false});
            })
          }
        }
      });
  }

  defineAreaForSurvey(data){
    let row:any = {teamID:null, qid:null};
    row.teamID = '0';
    row.qid= data.qid;
    row.teamName = this.groupName;
    row.surveyName = data.survey;
    let dialogRef = this.dialog.open(DefineAreaModalComponent, {
      height: '600px',
      width: '88rem',
      data: row
    })
    dialogRef.afterClosed().subscribe(result=>{
      if(result && result.surveyData){
        this.areaDefined.push({
          details:result.locations,
          lat:result.lat,
          lng:result.lng,
          qID:data.qid
        });
      }
    })
  }

  hasDefinedArea(row){
    for (let index = 0; index < this.areaDefined.length; index++) {
      if(this.areaDefined[index].qID == row.qid){
        return true;
      }
    }
    return false;
  }

  onGroupAdd()
  {
    amplitude.getInstance().logEvent('Addbuttonclickedafterclickingonaddnewteam');

    this.failMsg = "";
    if (this.groupName == null || isUndefined(this.groupName) || this.groupName == "") {
      this.groupEmpty = "on-error";
      return;
    }
    else {

      this.restApiService.createNewGroupService(this.groupName).subscribe(
        result => {
          if (result.success != false) {
            this.newGroupDialogRef.close(this.groupName);
          }
          else {
            this.failMsg = result.msg;
          }

        });
    }
  }

  onDiscard()
  {
    amplitude.getInstance().logEvent('Discardbuttonclickedafterclickingonaddnewteam');
    this.newGroupDialogRef.close({success:false});
  }

  hasSurveyor(){
    if(this.surveyorList.find(data=> data.action)){
      return true;
    }
    return false;
  }
  hasSurvey(){
    if(this.surveyList.find(data=> data.action)){
      return true;
    }
    return false;
  }
  
  createNewTeam(){
    if(!this.qId || this.qId == undefined){
      return;
    }
    if(this.qId.includes(undefined) || this.qId.includes('undefined') || this.qId.includes(null)){
      return;
    }
    if(!this.groupName || this.groupName.length == 0){
      return;
    }
    if(this.surveyorList){
      this.userId = [];
      this.surveyorList.forEach(data=>{
        if(data.action){
          this.userId.push(data.uid);
        }
      })
    }
    if(this.surveyList){
      this.qId = [];
      this.qNames = [];
      this.surveyList.forEach(data=>{
        if(data.action){
          this.qNames.push(data.survey);
          this.qId.push(data.qid);
        }
      })
    }
    this.restApiService.createTeamWithDetails(this.userId,this.groupName,this.qNames,this.qId,
      this.areaDefined).subscribe(response=>{
        this.newGroupDialogRef.close({success:true,teamName:this.groupName});
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/new-group-dialog/new-group-dialog.component.ts